import { isStaticExportPlaceholder, isValidEventWorkspaceId } from './resolve-static-param';

/**
 * Builds a clean participant quiz URL if valid eventId and activityId exist.
 * Returns null if either ID is missing, placeholder (__default), or invalid.
 */
export function buildParticipantUrl(
  eventSlugOrId?: string | null,
  activityId?: string | null
): string | null {
  if (
    !eventSlugOrId ||
    !activityId ||
    isStaticExportPlaceholder(eventSlugOrId) ||
    isStaticExportPlaceholder(activityId) ||
    !isValidEventWorkspaceId(activityId)
  ) {
    return null;
  }

  return `/participate/${encodeURIComponent(eventSlugOrId)}/${encodeURIComponent(activityId)}`;
}
